app.service('deliveryCompleting', function (accountConfig) {

	let config;

	function init() {
		config = accountConfig.getData();
		markDeliveryTimePageForOrderDisplayed();
	}

	function markDeliveryTimePageForOrderDisplayed() {

		const displayedOrders = JSON.parse(localStorage.getItem('customer-order-delivery-time')) || [];
		const orderDisplayed = displayedOrders.includes(config.orderNumber);

		if (!orderDisplayed) {
			displayedOrders.push(config.orderNumber);
			if (displayedOrders.length > 100) {
				displayedOrders.shift(); // Usuwa najstarszy wpis
			}
		}

		localStorage.setItem('customer-order-delivery-time', JSON.stringify(displayedOrders));
	}

	return {
		init
	};
});
